module.exports = __webpack_public_path__ + "img/Crystal_Logo.c96819ba.png";